module.exports = __webpack_public_path__ + "img/logo_cbs.d06cf070.png";